// Auto-generated by scripts/xliff-to-json.cjs -- do not edit by hand

export const translations: Record<string, string> = {
  's17f33773d05f3aed': `User Management`,
  'sb46734737dd208bb': `Audit Logs`,
  's36e195872312e3b4': `Site Administration`,
  's17669567f329206c': `Create Site`,
  's49730f3d5751a433': `Loading...`,
  's3741f519c32ac391': `New`,
  's417b90913e05bc17': `Preview`,
  'sffe2914d4b7c91ee': `Early Access`,
  's3d64ea063be4c9f2': `Unified Auditing`,
  's596a144afb429d94': `More Products`,
  's6d8c02aee480af7a': `Menu`,
  's6abb1cd87fe0114e': `Home`,
  's5e8250fb85d64c23': `Close`,
  's691d6163aaabb69b': `User Profile`,
  's352719d86112de9a': `Help`,
  'admin': `Administration`,
  'h88d78370fa007ca9': `Identity & Authentication Providers`,
  'sitemenu.dashboard': `Dashboard`,
  'sitemenu.dashboard.dynamicdashboard': `Dashboard (Preview)`,
  'sitemenu.assets': `Assets`,
  'sitemenu.smartrules': `Smart Rules`,
  'sitemenu.discovery': `Discovery`,
  'sitemenu.discovery.newdiscoveryscan': `Run a New Discovery Scan`,
  'sitemenu.discovery.activeandcompletedscans': `Active/Completed Scans`,
  'sitemenu.discovery.scheduledscans': `Scheduled Scans`,
  'sitemenu.discovery.discoveryscanners': `Discovery Scanners`,
  'sitemenu.managedsystems': `Managed Systems`,
  'sitemenu.managedaccounts': `Managed Accounts`,
  'sitemenu.passwordsafe': `Password Safe`,
  'sitemenu.passwordsafe.accounts': `Accounts`,
  'sitemenu.passwordsafe.approvals': `Approvals`,
  'sitemenu.passwordsafe.activesessions': `Active Sessions`,
  'sitemenu.passwordsafe.completedsessions': `Completed Sessions`,
  'sitemenu.passwordsafe.administratorsessions': `Admin Sessions`,
  'sitemenu.analyticsandreportingtrident': `Analytics & Reporting`,
  'sitemenu.analyticsandreporting.viewallreports': `View All Reports`,
  'sitemenu.teampasswords': `Secrets Safe`,
  'sitemenu.analytics': `Analytics & Reporting`,
  'sitemenu.configuration': `Configuration`,
  'sitemenu.about': `About`,
  'insights.menu.dashboard': `Dashboard`,
  'insights.menu.identitiesPrivileges': `Identities and Privileges`,
  'insights.menu.identities': `Identities`,
  'insights.menu.accounts': `Accounts`,
  'insights.menu.entitlements': `Entitlements`,
  'insights.menu.secretsSecurity': `Secrets Security`,
  'insights.menu.secrets': `Secrets`,
  'insights.menu.secretsInventory': `Secrets Inventory`,
  'insights.menu.aiSecurity': `AI Security`,
  'insights.menu.aiAgents': `AI Agents`,
  'insights.menu.agentInventory': `Agent Inventory`,
  'insights.menu.aiThreatDetection': `Threat Detection`,
  'insights.menu.aiThreatPolicy': `Threat Policy`,
  'insights.menu.insights': `Insights`,
  'insights.menu.detections': `Detections`,
  'insights.menu.recommendations': `Recommendations`,
  'insights.menu.exclusionRules': `Exclusion Rules`,
  'insights.menu.reporting': `Reporting`,
  'insights.menu.integrationsConnections': `Integrations and Connections`,
  'insights.menu.integrations': `Integrations`,
  'insights.menu.connectors': `Connectors`,
  'pmc.explore': `Explore`,
  'pmc.audit': `Audit`,
  'pmc.settings': `Settings`,
  'home': `Home`,
  'policies': `Policies`,
  'computers': `Computers`,
  'computer-groups': `Computer Groups`,
  'jit-access-management': `JIT Access Management`,
  'analytics': `Analytics`,
  'auditing': `Auditing`,
  'management-rules': `Management Rules`,
  'configuration': `Configuration`,
  'user-management': `User Management`,
  'status': `Status`,
  'downloads': `Consoles & Downloads`,
  'my_account': `My Account`,
  'sd': `Configuration`,
  'jump': `Asset Management`,
  'vault': `Vault`,
  'rep_console': `Console Settings`,
  'users': `Users & Security`,
  'reporting': `Reports`,
  'public_site': `Public Portals`,
  'dashboard': `Dashboards`,
  'localization': `Localization`,
  'management': `Management`,
  'appliance': `Appliance`,
  'login.status.index': `Information`,
  'login.status_representatives.index': `Representatives`,
  'login.downloads.rep.index': `Rep Console`,
  'login.downloads.drivers.index': `Drivers`,
  'login.my_account.profile.index': `Profile`,
  'login.my_account.security.index': `Security`,
  'login.sd_general.index': `Options`,
  'login.issue.index': `Issues`,
  'login.team.index': `Support Teams`,
  'login.skill.index': `Skills`,
  'login.callback_button.index': `Support Buttons`,
  'login.custom_fields.index': `Custom Fields`,
  'login.ms_teams.index': `MS Teams`,
  'login.mcp_config.index': `MCP Server`,
  'login.pinned_clients.index': `Jump Clients`,
  'login.shared_jump_groups.index': `Asset Groups`,
  'login.jump_policies.index': `Asset Policies`,
  'login.jump_item_roles.index': `Asset Roles`,
  'login.push_agent.index': `Gateway`,
  'login.jump_item.index': `Assets`,
  'login.endpoint_automation.index': `Endpoint Automation`,
  'login.vault_account.index': `Accounts`,
  'login.vault_account_group.index': `Account Groups`,
  'login.account_policy.index': `Account Policies`,
  'login.vault_endpoint.index': `Endpoints`,
  'login.vault_domain.index': `Domains`,
  'login.discovery.index': `Discovery`,
  'login.vault_options.index': `Options`,
  'login.vault_password_safe_connection.index': `Connections`,
  'login.rep_profile.index': `Rep Console Settings`,
  'login.custom_links.index': `Custom Links`,
  'login.canned_message.index': `Canned Messages`,
  'login.canned_script.index': `Canned Scripts`,
  'login.special_action.index': `Special Actions`,
  'login.user.index': `Users`,
  'login.rep_invite.index': `Rep Invite`,
  'login.security_providers.index': `Security Providers`,
  'login.session_policy.index': `Session Policies`,
  'login.group_policy.index': `Group Policies`,
  'login.kerberos_keytab.index': `Kerberos Keytab`,
  'login.licensing.index': `Licensing`,
  'login.session_report.index': `Support`,
  'login.license_reporting.index': `Licensing`,
  'login.vault_reporting.index': `Vault`,
  'login.compliance.index': `Compliance`,
  'login.jump_item_reporting.index': `Asset`,
  'login.duplicate_pinned_clients_reporting.index': `Duplicate Jump Clients`,
  'login.syslog_reporting.index': `Syslog`,
  'login.public_site.index': `Public Sites`,
  'login.business_hours.index': `Schedule`,
  'login.html_template.index': `HTML Templates`,
  'login.customer_notice.index': `Customer Notices`,
  'login.file_store.index': `File Store`,
  'login.ios_profile.index': `iOS Configuration`,
  'login.exit_survey.index': `Exit Surveys`,
  'login.sd_client.index': `Customer Client`,
  'login.dashboard.index': `Dashboards`,
  'login.dashboard.getNetworkRestrictions': `Network Restrictions`,
  'login.nls.real_time_chat.index': `Real-Time Chat`,
  'login.settings.index': `Software`,
  'login.security_settings.index': `Security`,
  'login.site_settings.index': `Site Configuration`,
  'login.email_settings.index': `Email Configuration`,
  'login.outbound_event.index': `Outbound Events`,
  'login.api_account.index': `API Configuration`,
  'login.support_settings.index': `Support`,
  'login.appliance.index': `Appliance`,
  'entitle.menu.requests': `Requests`,
  'entitle.menu.identityGraph': `Permissions`,
  'entitle.menu.workflows': `Approval workflows`,
  'entitle.menu.integrations': `Integrations`,
  'entitle.menu.bundles': `Bundles`,
  'entitle.menu.policies': `Birthright policies`,
  'entitle.menu.tasks': `Tasks`,
  'entitle.menu.profile': `My settings`,
  'entitle.menu.accessReview': `Overview`,
  'entitle.menu.requestsLog': `Request history`,
  'entitle.menu.auditLogs': `Audit logs`,
  'entitle.menu.settings': `Org settings`,
  'entitle.menu.users': `Users`,
  'epml.menu.explore': `Explore`,
  'epml.menu.audit': `Audit`,
  'epml.menu.settings': `Settings`,
  'epml.menu.policy': `Policy`,
  'epml.menu.endpoints': `Endpoint Management`,
  'epml.menu.installers': `Installers`,
  'epml.menu.unifiedSearch': `Unified Search`,
  'epml.menu.events': `Events`,
  'epml.menu.consoleAudit': `Console Audit`,
  'epml.menu.searchAndReplay': `Search and Replay`,
  'epml.menu.consoleAccess': `Console Access`,
  'epml.menu.epmlSettings': `EPML Settings`,
  'epml.menu.roles': `Roles`,
  'epml.menu.siemConnections': `SIEM Connections`,
  'epml.menu.directoryServices': `Directory Services`,
  'epml.menu.linuxHostAuth': `Linux Host Authentication`,
  'menu-phantom-labs': `Phantom Labs`,
  'ai-coworkers.menu.dashboards': `Dashboard`,
  'ai-coworkers.menu.inventory': `Visibility`,
  'ai-coworkers.menu.inventory.agents': `AI Agents`,
  'ai-coworkers.menu.inventory.mcp-servers': `MCP Servers`,
  'ai-coworkers.menu.inventory.model-endpoints': `LLM Endpoints`,
  'ai-coworkers.menu.inventory.agent-skills': `Agent Skills`,
  'ai-coworkers.menu.inventory.endpoints': `Endpoints`,
  'ai-coworkers.menu.intelligence': `Intelligence`,
  'ai-coworkers.menu.agents.events': `Events`,
  'ai-coworkers.menu.intelligence.coding-sessions': `AI Sessions`,
  'ai-coworkers.menu.control': `Protection`,
  'ai-coworkers.menu.control.policies': `Policies`,
  'ai-coworkers.menu.control.exceptions': `Exception Requests`,
  'ai-coworkers.menu.control.yara-rules': `YARA Rules`,
  'ai-coworkers.menu.settings': `Settings`,
  'ai-coworkers.menu.settings.connectors': `Connectors`,
  'ai-coworkers.menu.settings.license': `License & Usage`,
  'ai-coworkers.menu.settings.administration': `Administration`,
  'ai-coworkers.menu.agents.deployment': `Deployment`,
  'ai-coworkers.menu.settings.update-strategy': `Update Strategy`,
  'sa91c1893f06e9a91': `SCIM Tokens`,
  'sb5cd73af5ec790f6': `Workload Identities`,
  's29c1fa87a0c0ee4c': `Directory Authentication`,
  's177fa3e0b2ef5171': `IP Allowlist`,
  's4c9351ce0cc28196': `Product navigation`,
  's76902262e33e63b5': `Toggle sidebar navigation`,
  's714ea1e6436002a2': `Pin navigation open`,
  's416434bef0c17abc': `Unable to load the menu. Close and reopen it to try again.`,
  'admin.menu.users': `User Management`,
  'admin.menu.identity-providers': `Identity & Authentication Providers`,
  'admin.menu.directory-auth': `Directory Authentication`,
  'admin.menu.workload-identities': `Workload Identities`,
  'admin.menu.scim-tokens': `SCIM Tokens`,
  'admin.menu.user-groups': `User Groups`,
  'admin.menu.roles': `Roles`,
  'admin.menu.organization-settings': `Organization Settings`,
  'admin.menu.ip-allowlist': `IP Allowlist`,
  'admin.menu.audit': `Audit Logs`,
  'admin.menu.site-admin': `Site Administration`,
  'admin.menu.site-admin.create': `Create Site`,
  'siteSelectorLabel': `Site`,
  'siteSelectorSearchPlaceholder': `Search sites`,
  'siteSelectorNoSitesFound': `No sites found`,
  'siteSelectorDataResidency': `data residency`,
  'breadcrumbNavLabel': `Breadcrumb`,
  'breadcrumbOverflowLabel': `Show more breadcrumbs`,
};
